module.exports = __webpack_public_path__ + "static/media/w-logo.d053f2c1.jpg";